const localUser=JSON.parse(localStorage.getItem("user"))
const localBasket=JSON.parse(localStorage.getItem(`cart.${localUser}`))
export const initialState={
    basket:localBasket?localBasket:[],
    user:null,
    admin_search:[],
    admin_search_loading:false,
    admin_search_sorted:[]
};

export const getBasketTotal=(basket)=>
basket?.reduce((amount,item)=>(item.price*item.count)+amount,0);

const reducer=(state,action)=>{
    switch(action.type){
        case "ADMIN_SEARCH_SORTED":{
            return{
                ...state,
                admin_search_sorted:action.payload
            }
        }
        case "ADMIN_SEARCH_LOADING":{
            return{
                ...state,
                admin_search_loading:action.payload
            }
        }
        case "ADMIN_SEARCH_PRODUCTS":
            return{
                ...state,
                admin_search:action.payload
            }
        case "UPDATE_PRODUCT_PRICE":
      return {
        ...state,
        basket:     state.basket.map((item) =>
            item.id === action.payload._id
              ? { ...item, price: action.payload.newPrice,stock:action.payload.newStock,count:action.payload.count }
              : item
          )
      }
 
        case 'FETCH_BASKET':
            return{
                ...state,
                basket:action.item.cart
            }
        case 'SET_USER':
            return{
                ...state,
                user:action.user,
            }
        case 'ADD_TO_BASKET':
            return {
                ...state,
                basket:[...state.basket,action.item]
            };
        case 'UPDATE':
            return{
                ...state
            }
        case 'EMPTY_BASKET':
            return{
                ...state,
                basket:[]
            }
        case 'REMOVE_FROM_BASKET':
            let newBasket=[...state.basket];
            const index=state.basket.findIndex((basketItem)=>basketItem.id===action.id);
            if(index>=0){
                newBasket.splice(index,1);
                
            }else{

            }
            return {...state,basket:newBasket};
        break;
        default:
            return state;
    }
}
export default reducer;